/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React from "react";
import PropTypes from "prop-types";
import { useStateValue } from "../../SharedContext";
import { getTextColor } from "../../../utils/utils";

import "./story-headline.m.css";

export const StoryHeadline = ({ story }) => {
  const config = useStateValue() || {};
  const textColor = getTextColor(config.theme);
  return (
    <h1 className="arrow-component arr--story-headline" data-testid="headline" styleName={`headline ${textColor}`}>
      <bdi dangerouslySetInnerHTML={{ __html: story.headline }} />
    </h1>
  );
};

StoryHeadline.propTypes = {
  story: PropTypes.object.isRequired
};
